<template>
  <div class="table-action">
    <div class="table-action__container">
      <a
        v-for="(item, idx) in items"
        :key="idx"
        class="anchor-link ms-2"
        href="javascript:void(0)"
        @click.prevent="$emit(item.action, selectedRow)"
      >
        {{ item.text }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "table-action",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    // selected row
    selectedRow: {
      type: Object,
      default: () => ({}),
    },
    // selected index
    index: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    isShown: false,
  }),
  methods: {
    showDropdown() {
      this.isShown = !this.isShown;
    },
  },
};
</script>

<style></style>
